import { oneOfType, string, object, bool } from 'prop-types';
import React, { useEffect, useRef } from 'react';
import classNames from 'classnames/bind';
import get from 'lodash/get';
import { metaDataElement, metaDataProperty } from '../../utils/cmPreviewMetaData';
import * as styles from '../DHTML/DHTML.css';

const cx = classNames.bind(styles);

const DHTML = (props) => {
    const data = get(props, 'data', props);
    const { isCMPreview } = props;
    const { automationId } = data;
    let { html } = data;
    const dhtmlWrapper = useRef(null);
    let insertScript = [];

    useEffect(() => {
        if (insertScript && insertScript?.length) {
            insertScript?.forEach((currentScript) => {
                const s = document?.createElement('script');
                s.type = 'text/javascript';
                s.async = true;
                s.innerHTML = currentScript;
                dhtmlWrapper?.current?.appendChild(s);
            });
        }
    }, []);

    const setCopyText = () => {
        // Pattern to extract all script tags except script tag with src attribute
        const scriptPattern = /(<script(((?!src).)*?>))[^<]*<\/script>/g;
        if (html && html?.length > 0) {
            const containsScript = html?.match(scriptPattern);
            if (containsScript && containsScript?.length) {
                insertScript = containsScript?.map(
                    (currentScript) => currentScript?.replace(/(<|<\/)script[^>]*>/g, ''),
                    ''
                );
                html = html?.replace(scriptPattern, '');
            }
            return (
                <section className={cx('rowBlock', 'bgWhite', 'clearFix')}>
                    <div className={cx('seoContent')}>
                        <div
                            ref={dhtmlWrapper}
                            data-cm-metadata={isCMPreview && metaDataProperty('html')}
                        >
                            {/* eslint-disable react/no-danger */}
                            <div dangerouslySetInnerHTML={{ __html: html }} />
                        </div>
                    </div>
                </section>
            );
        }

        return null;
    };
    return (
        <div
            data-cm-metadata={isCMPreview && metaDataElement(data)}
            data-automation-id={automationId}
        >
            {setCopyText()}
        </div>
    );
};

DHTML.defaultProps = {
    html: {},
    automationId: '',
    isCMPreview: false,
};

DHTML.propTypes = {
    html: oneOfType([object, string]),
    /**
     * Unique name for referencing dom element in automation testing
     * @type {String}
     */
    automationId: string,
    isCMPreview: bool,
};

export default DHTML;
